// Draw Widget

// Import Esri Components
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";

import DrawHandler from "./DrawHandler";

import React, { Fragment, useEffect, useState } from "react";
import { TwitterPicker } from "react-color";
import Slider from "react-input-slider";

import {
  Segment,
  Icon,
  Menu,
  Dropdown,
  Modal,
  Button,
  Input,
  Popup,
} from "semantic-ui-react";

// import "./draw_widget.css";
// import styles from "./Button.draw_widget.css";

export default class DrawWidget extends React.Component {
  constructor(props) {
    super();

    // console.log("DrawWidget", props);

    this.state = {
      tool: null,
      active: false,
      method: null,
      index: 0,
      color: { r: 0, g: 0, b: 0, a: 0.8 },
      hex: "#000000",
      opacity: 0.8,
      text: "",
      selected_type: null,
      selected_graphic: null,
      text_prompt: false,

      popup_open: false,
    };

    // Bind
    this.start = this.start.bind(this);
    this.undo = this.undo.bind(this);
    this.redo = this.redo.bind(this);
    this.colorChange = this.colorChange.bind(this);
    this.opacityChange = this.opacityChange.bind(this);
    this.edit = this.edit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.delete = this.delete.bind(this);
    this.textChange = this.textChange.bind(this);
  }

  initialize() {
    // Find the layer and the DrawHandlerLayer
    this.layer = this.view.map.allLayers.find((layer) => {
      return layer.id === "drawLayer";
    });
    this.draw_handler_layer = this.view.map.allLayers.find((layer) => {
      return layer.id === "drawHandlerLayer";
    });

    // If the layer doesn't exist
    if (!this.layer) {
      this.draw_handler_layer = new GraphicsLayer({
        id: "drawHandlerLayer",
      });
      this.layer = new GraphicsLayer({
        id: "drawLayer",
        print: true,
      });

      // Add the layer to the map
      this.view.map.layers.addMany([this.layer, this.draw_handler_layer]);
    } else {
      this.setState({
        index: this.layer.graphics.length,
      });
    }

    // symbology
    this.polygon_symbol = {
      type: "simple-fill",
      color: this.state.color,
    };
    this.polyline_symbol = {
      type: "simple-line",
      width: 2,
      color: this.state.color,
    };
    this.point_symbol = {
      type: "simple-marker",
      size: 15,
      color: this.state.color,
    };
    this.text_symbol = {
      type: "text",
      color: "black",
      // haloColor: "black",
      // haloSize: "2px",
      text: this.state.text,
      // xoffset: 0,
      // yoffset: 0,
      // horizontalAlignment: "justify",
      font: {
        size: 12,
        family: "sans-serif",
        weight: "bold",
      },
    };

    // Draw Handler
    this.draw_handler = new DrawHandler({
      polygon_symbol: {
        type: "simple-fill",
      },
      polyline_symbol: {
        type: "simple-line",
        width: 2,
      },
      point_symbol: {
        type: "simple-marker",
        size: 15,
        color: [70, 70, 70, 0.84],
      },
      view: this.view,
      layer: this.draw_handler_layer,
      clear_graphic: true,
    });

    // On complete
    this.draw_handler.on("completed", (geometry) => {
      var graphic = new Graphic({
        geometry: geometry,
        attributes: {
          index: this.state.index,
        },
      });

      graphic = this.setSymbology(graphic);
      this.layer.graphics.add(graphic);

      this.setState({
        index: this.state.index + 1,
        active: false,
        method: null,
        text: "",
      });
    });
  }

  setSymbology(graphic) {
    if (this.state.tool === "text" || this.state.selected_type === "text") {
      graphic.symbol = this.text_symbol;
    } else {
      switch (graphic.geometry.type) {
        case "point":
          graphic.symbol = this.point_symbol;
          break;
        case "polygon":
          graphic.symbol = this.polygon_symbol;
          break;
        case "polyline":
          graphic.symbol = this.polyline_symbol;
          break;
        default:
        // code block
      }
    }
    return graphic;
  }

  start(tool) {
    this.setState(
      {
        active: true,
        method: "create",
        tool: tool,
      },
      () => {
        this.initializePopup();
        if (["polyline", "point", "polygon"].includes(tool)) {
          this.draw_handler.start(tool);
        } else if (tool === "text") {
          this.setState({
            text_prompt: true,
          });
        }
      }
    );
  }

  edit() {
    this.cancel();
    this.setState(
      {
        active: true,
        method: "edit",
      },
      () => {
        this.initializePopup();

        // SketchViewModel
        this.sketch = new SketchViewModel({
          layer: this.layer,
          view: this.view,
          updateOnGraphicClick: false,
        });

        this.sketch.on("update", (event) => {
          if (event.state === "complete") {
            this.setSymbology(event.graphics[0]);

            var obj = {
              selected_graphic: null,
            };

            if (this.layer.graphics.items.length === 0) {
              obj.index = 0;
            }

            this.setState(obj, () => {
              this.cancelEdit();
            });
          }
        });

        this.handler = this.view.on("click", (event) => {
          this.view.hitTest(event).then((response) => {
            // return the grpahics from the htitest
            var results = response.results.map((record) => {
              return record.graphic;
            });

            // Get the
            var graphics = results.filter((graphic) => {
              return graphic.attributes.hasOwnProperty("index");
            });

            if (graphics.length === 1) {
              // get the first graphic
              var graphic = graphics[0];

              // Check if the color matches
              if (
                this.state.selected_graphic &&
                graphic.attributes.index ===
                  this.state.selected_graphic.attributes.index
              ) {
                return;
              }

              if (
                graphic.symbol.color.toHex() !== this.state.color &&
                graphic.symbol.type !== "text"
              ) {
                this.setState(
                  {
                    color: graphic.symbol.color,
                    hex: graphic.symbol.color.toHex(),
                    selected_type: graphic.symbol.type,
                    selected_graphic: graphic,
                  },
                  () => {
                    // Set the symbol colors
                    this.polygon_symbol.color = this.state.color;
                    this.polyline_symbol.color = this.state.color;
                    this.point_symbol.color = this.state.color;

                    // start up the sketch
                    if (this.sketch.state === "ready") {
                      this.sketch.update(graphic);
                    }
                  }
                );
              } else if (this.sketch.state === "ready") {
                this.setState(
                  {
                    selected_type: graphic.symbol.type,
                    selected_graphic: graphic,
                  },
                  () => {
                    this.sketch.update(graphic);
                  }
                );
              }
            }
          });
        });

        // this.initializePopup();
      }
    );
  }

  delete() {
    // sort the graphics by index value
    var layer_graphics = [...this.layer.graphics.items].sort(
      (a, b) => a.attributes.index - b.attributes.index
    );

    // reference values
    var graphics = [];
    var cur_index = 0;
    var found = false;

    layer_graphics.forEach((graphic) => {
      // Check if the graphic index matches the one to delete
      // if so then do not update the cur index and do not push to the array
      // if not and the found is updated then add the cur index and increment it by one
      if (
        graphic.attributes.index ===
        this.state.selected_graphic.attributes.index
      ) {
        cur_index = this.state.selected_graphic.attributes.index;
        found = true;
      } else {
        if (found) {
          graphic.attributes.index = cur_index;
          cur_index++;
        }
        graphics.push(graphic);
      }
    });

    if (found) {
      this.layer.graphics.removeAll();
      this.layer.graphics.addMany(graphics);

      // Update the state by subtracting one
      this.setState(
        {
          index: this.state.index > 0 ? this.state.index - 1 : 0,
        },
        () => {
          if (this.layer.graphics.items.length === 0) {
            this.cancelEdit();
          }
        }
      );
    }
  }

  cancelEdit() {
    // this.clearHandler();
    if (this.sketch && !this.sketch.destroyed) {
      this.sketch.destroy();
      this.handler.remove();
      this.handler = null;
      this.setState({
        active: false,
        method: null,
        tool: null,
        selected_type: null,
        selected_graphic: null,
      });
    }
  }

  cancel() {
    this.setState(
      {
        active: false,
        method: null,
        tool: null,
        text: "",
        selected_type: null,
        selected_graphic: null,
      },
      () => {
        this.draw_handler.end();
        // this.clearHandler();
        if (this.sketch && !this.sketch.destroyed) {
          this.sketch.destroy();
          this.handler.remove();
          this.handler = null;
        }
      }
    );
  }

  undo() {
    const index = this.state.index - 1;

    if (this.state.index > 0) {
      this.layer.graphics.items.forEach((graphic) => {
        if (graphic.attributes.index >= index) {
          graphic.visible = false;
        }
      });

      this.setState({
        index: index,
      });
    }
  }

  redo() {
    let total = 0;

    this.layer.graphics.items.forEach((graphic) => {
      if (graphic.attributes.index <= this.state.index && !graphic.visible) {
        total++;
        graphic.visible = true;
      }
    });

    if (total > 0) {
      this.setState({
        index: this.state.index + 1,
      });
    }
  }

  colorChange(e) {
    var color = e.rgb;
    color.a = this.state.opacity;

    this.setState(
      {
        color: color,
        hex: e.hex,
      },
      () => {
        this.polygon_symbol.color = this.state.color;
        this.polyline_symbol.color = this.state.color;
        this.point_symbol.color = this.state.color;
      }
    );
  }

  opacityChange(e) {
    var color = { ...this.state.color };
    color.a = e.x;

    this.setState(
      {
        opacity: e.x,
        color: color,
      },
      () => {
        this.polygon_symbol.color = this.state.color;
        this.polyline_symbol.color = this.state.color;
        this.point_symbol.color = this.state.color;
      }
    );
  }

  textChange(text) {
    this.setState(
      {
        text: text,
        text_prompt: false,
      },
      () => {
        this.text_symbol.text = this.state.text;
        this.draw_handler.start("point");
      }
    );
  }

  initializePopup() {
    // $("#draw_color_button").popup({
    //   popup: $("#draw_color_picker_popup"),
    //   on: "click",
    // });
  }

  componentDidMount() {
    // Initialize when the view is loaded
    // => Apparently ESRI can't just trip this if the view is loaded... so I have to check the property manually as well
    if (this.props.view.ready) {
      this.view = this.props.view;
      this.initialize();
    } else {
      this.props.view.when(() => {
        this.view = this.props.view;
        this.initialize();
      });
    }
  }

  componentWillUnmount() {
    // Destroy the draw handler and the sketch
    this.draw_handler.end();

    if (this.sketch && !this.sketch.destroyed) {
      this.sketch.destroy();
      this.handler.remove();
      this.handler = null;
    }

    // Remove any graphics that are invisible
    this.layer.graphics.forEach((graphic) => {
      if (!graphic.visible) {
        this.layer.remove(graphic);
      }
    });
  }

  render() {
    return (
      <div
        id="draw_container"
        style={{ position: "absolute", bottom: "15px", left: "15px" }}
      >
        <Segment>
          {this.renderMenu()}
          {this.renderOptions()}
          {this.renderEditButton()}
        </Segment>
        <RenderTextModal
          open={this.state.text_prompt}
          callback={this.textChange}
          timestamp={new Date().valueOf()}
        />
      </div>
    );
  }

  renderMenu() {
    if (!this.state.active && this.state.method !== "edit") {
      return (
        <Menu compact size="mini">
          <Menu.Item onClick={this.undo}>
            <Icon name="undo" className="no-mragin" />
          </Menu.Item>
          <Dropdown item text="Select Feature">
            <Dropdown.Menu>
              <Dropdown.Item
                icon={<Icon className="esri-icon-radio-unchecked icon" />}
                text="Point"
                onClick={() => this.start("point")}
              />
              <Dropdown.Item
                icon={<Icon className="esri-icon-polygon icon" />}
                text="Polygon"
                onClick={() => this.start("polygon")}
              />
              <Dropdown.Item
                icon={<Icon className="esri-icon-polyline icon" />}
                text="Polyline"
                onClick={() => this.start("polyline")}
              />
              <Dropdown.Item
                icon={<Icon className="font icon" />}
                text="Text"
                onClick={() => this.start("text")}
              />
            </Dropdown.Menu>
          </Dropdown>
          <Menu.Item onClick={this.redo}>
            <Icon name="redo" className="no-mragin" />
          </Menu.Item>
        </Menu>
      );
    }
  }

  renderOptions() {
    if (this.state.active) {
      return (
        <div className="ui grid" style={{ width: "220px" }}>
          <div className="four wide column">
            <Popup
              content={
                <TwitterPicker
                  triangle={"hide"}
                  onChangeComplete={this.colorChange}
                />
              }
              on="click"
              onClose={() => this.setState({ popup_open: false })}
              onOpen={() => this.setState({ popup_open: true })}
              open={this.state.popup_open}
              trigger={
                <Button
                  id="draw_color_button"
                  style={{
                    backgroundColor: this.state.hex,
                  }}
                />
              }
            />
          </div>
          <div className="twelve wide column">
            <Slider
              axis="x"
              x={this.state.opacity}
              xmin={0}
              xmax={1.0}
              xstep={0.1}
              onChange={this.opacityChange}
              styles={{ track: { maxWidth: "100%", marginTop: "1.5em" } }}
            />
          </div>
        </div>
      );
    }

    return null;
  }

  renderEditButton() {
    if (this.state.index > 0 && this.layer && this.layer.graphics.length > 0) {
      if (this.state.active && this.state.method === "edit") {
        return (
          <div className="ui fluid small buttons" style={{ marginTop: "10px" }}>
            {this.state.selected_graphic ? (
              <button
                id="draw_edit_cancel_btn"
                className="ui secondary button"
                onClick={this.delete}
              >
                Delete
              </button>
            ) : null}
            <button
              id="draw_edit_cancel_btn"
              className="ui red button"
              onClick={this.cancelEdit}
            >
              Stop Editing
            </button>
          </div>
        );
      } else {
        return (
          <Fragment>
            <br />
            <button
              id="draw_edit_btn"
              className="ui fluid secondary small button"
              onClick={this.edit}
              style={{ marginTop: "10px" }}
            >
              <i className="ui edit icon"></i>
              Edit
            </button>
          </Fragment>
        );
      }
    }
  }
}

function RenderTextModal(props) {
  const [open, setOpen] = useState(props.open);
  const [text, setText] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    setOpen(props.open);
    setMessage("");
  }, [props.timestamp]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal id="drawing-text-modal" size="tiny" open={open}>
      <Modal.Header>Enter Cutom Text</Modal.Header>
      <Modal.Description className="text-center padding">
        {message.length > 0 && <p style={{ color: "red" }}>{message}</p>}
        <Input
          focus
          onChange={(e) => setText(e.target.value)}
          style={{ width: "100%" }}
        />
      </Modal.Description>
      <Modal.Actions>
        <Button color="black" onClick={() => setOpen(false)}>
          Cancel
        </Button>

        <Button
          primary
          icon
          labelPosition="right"
          onClick={() => handleSubmit()}
        >
          Submit
          <Icon name="check" />
        </Button>
      </Modal.Actions>
    </Modal>
  );

  function handleSubmit() {
    if (text.length === 0) {
      setMessage("Enter text to display on map");
    } else {
      props.callback(text);
    }
  }
}
